export default __webpack_public_path__ + "static/mini-helix-bq-4-451c8b957ede1f1bba933b9108110482.jpg";